module.exports = __webpack_public_path__ + "img/hr-MyGoals.d52b35a6.png";